<template>
    <div>
        <v-text-field label="Asset Id" v-model="assetId"></v-text-field>
        <v-btn depressed @click="fetchMuxAsset">Download</v-btn>
    </div>
</template>

<script>
import { mapActions } from 'pinia';
import AdminToolService from '@/services/adminTool.service';
import { useGlobalState } from '@/stores/globalState';
export default {
    data() {
        return {
            assetId: null,
            api: null,
            token: null,
        };
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),
        async fetchMuxAsset() {
            try {
                if (!this.assetId) throw new Error('Asset id cannot be null');

                var response = await this.api.fetchMuxAssetDownloadUrl(this.assetId);

                console.log(response, 'asset response');

                if (response?.data?.url) {
                    this.showSnackbar({ message: 'Downloading Asset' });

                    this.downloadWithLink(response?.data?.url);
                } else if (response.data.message) {
                    this.showSnackbar({ message: response.data.message });
                }
            } catch (err) {
                console.log(err, 'error fetching mux asset');
                this.showSnackbar({ message: 'Error fetching asset', color: 'error' });
            }
        },
        downloadWithLink(url) {
            // const filename = 'my-video.mp4'; // Optional custom filename

            const link = document.createElement('a');
            link.href = url;
            // link.download = filename; // This suggests a filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async setAuthToken() {
            const response = await this.$auth.getIdTokenClaims();
            this.token = response.__raw;
        },
    },
    async mounted() {
        await this.setAuthToken();

        this.api = AdminToolService(this.token);
    },
};
</script>

<style lang="scss" scoped></style>
